/* eslint-disable react/display-name */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
import 'twin.macro'
import './index.css'

import CalendarIcon from 'assets/icons/CalendarIcon'
import CloseIcon from 'assets/icons/CloseIcon'
import SubBody from 'components/UI/sub-body/sub-body'
import SubTitle from 'components/UI/sub-title/sub-title'
import { kk } from 'date-fns/locale/kk'
import { ru } from 'date-fns/locale/ru'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useRef, useState } from 'react'
import { forwardRef } from 'react'
import ReactDatePicker, { CalendarContainer, registerLocale } from 'react-datepicker'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import Modal from '../modal/modal'
import ReactPortal from '../portal'

registerLocale('kk', kk)
registerLocale('ru', ru)

function DatePickerInput({ startDate, setStartDate, endDate, setEndDate }) {
  const [open, setOpen] = useState(true)
  const { isMobile } = useDeviceInfo()

  const { control } = useForm()
  const { t, i18n } = useTranslation()
  const dateRef = useRef<ReactDatePicker>()

  const onChange = dates => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => {
    return (
      <div>
        <button
          className='example-custom-input'
          tw='flex justify-between items-center w-full'
          onClick={onClick}
          ref={ref}
        >
          <div tw='text-left'>
            <SubBody twStyle={tw`text-secondary`}>{t('statement.period', { ns: 'cabinet' })}</SubBody>
            <SubTitle variant='bold'>{value}</SubTitle>
          </div>
          <button tw='rounded-s12 bg-primary p-2'>
            <CalendarIcon />
          </button>
        </button>
      </div>
    )
  })

  const Container = ({ className, children }) => {
    const { isMobile } = useDeviceInfo()
    return isMobile ? (
      <ReactPortal>
        <CalendarContainer className={className}>
          <div tw='sm:mb-5 bg-secondary p-5 pb-3 rounded-s30 rounded-bl-none rounded-br-none w-[100vw]'>
            <div tw='flex w-full justify-between'>
              <SubTitle twStyle={tw`sm:font-sans font-medium text-s18`}>
                {t('statement.datepicker.title', { ns: 'cabinet' })}
              </SubTitle>
              <CloseIcon onClick={() => dateRef.current?.setOpen(false)} />
            </div>
            <div tw='flex justify-between w-full px-5 mt-5 text-secondary'>
              <div>Пн</div>
              <div>Вт</div>
              <div>Ср</div>
              <div>Чт</div>
              <div>Пт</div>
              <div>Сб</div>
              <div>Вс</div>
            </div>
          </div>

          <div tw='relative flex flex-col items-center w-full'>{children}</div>
        </CalendarContainer>
      </ReactPortal>
    ) : (
      <div tw='flex flex-col sm:w-[500px] absolute top-0 -left-20 sm:-left-96 z-50'>
        <CalendarContainer className={className}>
          <div tw='mb-5 mt-2'>
            <SubTitle twStyle={tw`ml-5`}>{t('statement.datepicker.title', { ns: 'cabinet' })}</SubTitle>
          </div>
          <div tw='relative'>{children}</div>
        </CalendarContainer>
      </div>
    )
  }

  return (
    <div tw='sm:relative w-full'>
      <ReactDatePicker
        selected={startDate}
        onChange={onChange}
        popperPlacement={isMobile ? 'left' : 'bottom'}
        startDate={startDate}
        endDate={endDate}
        monthsShown={2}
        ref={dateRef}
        maxDate={new Date()}
        onClickOutside={() => isMobile && dateRef.current?.setOpen(true)}
        locale={i18n.language === 'kk' ? 'kk' : 'ru'}
        dateFormat={'dd/MM/yyyy'}
        calendarContainer={Container}
        selectsRange={true}
        customInput={<ExampleCustomInput />}
      />
    </div>
  )
}

export default DatePickerInput
